import { PageError } from '@/components/PageError'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

export const Route = createFileRoute('/_auth/_modules/_shared/_errors/error')({
  component: RouteComponent,
  validateSearch: zodValidator(
    z.object({
      redirect: z.string(),
      message: z.string().optional(),
    }),
  ),
  beforeLoad: async ({ search }) => {
    if (!search.redirect) throw redirect({ to: '/welcome' })
  },
})

function RouteComponent() {
  const { message } = Route.useSearch()

  return <PageError message={message} />
}
